export passengerFieldsReducer = (state = [], action) ->
  state
